module.exports = __webpack_public_path__ + "static/media/girls-head.cbe74564.png";